import api from '../utils/api';

export interface TrialStateOption {
  professionID: string;
  stateID: number;
  cycleCount: number;
}

export interface TrialStatus {
  isTrialing: boolean;
  trialEndsAt: string | null;
  daysLeft: number;
  stateOptions: TrialStateOption[];
  chosenProfessionID: string | null;
  chosenStateID: number | null;
}

export const getTrialStatus = async (): Promise<TrialStatus> => {
  const res = await api.get<TrialStatus>('/api/users/me/trial-status');
  return res.data;
};

export const setTrialPrimary = async (professionID: string, stateID: number): Promise<void> => {
  await api.put('/api/users/me/trial-primary', { professionID, stateID });
};
